import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "至", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "（留空结束名次表示只针对单个名次）", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "0 = 不限制；填 3 表示用户当日流水 ≥ 奖品回收价 × 3 才发放", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "jm: 流水门槛（元）；tws: 明信片张数", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "数值越小越靠前", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("奖励项配置")
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("+ 添加商品")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("+ 添加优惠券")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("商品")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("优惠券")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("固定数量")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("流水百分比")
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "ms-2" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "百分比（0.03 = 3%），仅 jm 流水模式有效", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.config,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "配置名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.config.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.name) = $event)),
              placeholder: "请输入配置名称",
              style: {"width":"300px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "奖励类型",
          prop: "reward_type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.config.reward_type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.reward_type) = $event)),
              placeholder: "请选择类型",
              disabled: !_ctx.isNew,
              onChange: _ctx.onRewardTypeChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "排名奖励",
                  value: "rank"
                }),
                _createVNode(_component_el_option, {
                  label: "门槛奖励",
                  value: "threshold"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled", "onChange"])
          ]),
          _: 1
        }),
        (_ctx.config.reward_type === 'rank')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_form_item, {
                label: "排名范围",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.config.rank_start,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.rank_start) = $event)),
                    min: 1,
                    placeholder: "起始名次"
                  }, null, 8, ["modelValue"]),
                  _hoisted_2,
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.config.rank_end,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.rank_end) = $event)),
                    min: _ctx.config.rank_start || 1,
                    placeholder: "结束名次"
                  }, null, 8, ["modelValue", "min"]),
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "最低流水倍率" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.config.min_water_multiplier,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.config.min_water_multiplier) = $event)),
                    min: 0,
                    precision: 2,
                    step: 0.5,
                    placeholder: "0"
                  }, null, 8, ["modelValue", "step"]),
                  _hoisted_4
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.config.reward_type === 'threshold')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_el_form_item, {
                label: "门槛数量",
                prop: "threshold_count"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.config.threshold_count,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.config.threshold_count) = $event)),
                    min: 1
                  }, null, 8, ["modelValue"]),
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "取最高档位" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.config.winner_take_highest,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.config.winner_take_highest) = $event)),
                    "active-text": "仅发最高满足档位",
                    "inactive-text": "满足多档则叠加发放"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "排序权重",
          prop: "sort_order"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.config.sort_order,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.config.sort_order) = $event)),
              min: 0
            }, null, 8, ["modelValue"]),
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "状态",
          prop: "status"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.config.status,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.config.status) = $event)),
              "active-value": "active",
              "inactive-value": "inactive",
              "active-text": "启用",
              "inactive-text": "停用"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider, { "content-position": "left" }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addItem('product')))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            size: "small",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addItem('point')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("+ 添加" + _toDisplayString(_ctx.pointLabel), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "warning",
            size: "small",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addItem('coupon')))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_table, {
          data: _ctx.visibleItems,
          border: "",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "奖励类型",
              width: "120"
            }, {
              default: _withCtx(({ row }) => [
                (row.item_type === 'product')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }))
                  : (row.item_type === 'point')
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "success",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.pointLabel), 1)
                        ]),
                        _: 1
                      }))
                    : (row.item_type === 'coupon')
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 2,
                          type: "warning",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "奖励内容",
              "min-width": "250"
            }, {
              default: _withCtx(({ row }) => [
                (row.item_type === 'product')
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      modelValue: row.product_id,
                      "onUpdate:modelValue": ($event: any) => ((row.product_id) = $event),
                      filterable: "",
                      remote: "",
                      "remote-method": _ctx.searchProducts,
                      loading: _ctx.productSearchLoading,
                      placeholder: "输入关键字搜索商品",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productOptions, (product) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: product.id,
                            label: `${product.name} (ID: ${product.id})`,
                            value: product.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "remote-method", "loading"]))
                  : (row.item_type === 'point')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_el_radio_group, {
                          modelValue: row._reward_mode,
                          "onUpdate:modelValue": ($event: any) => ((row._reward_mode) = $event),
                          size: "small",
                          class: "mb-2",
                          onChange: (v) => _ctx.onPointModeChange(row, v)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "fixed" }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "rate" }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]),
                        (row._reward_mode === 'fixed')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_el_input_number, {
                                modelValue: row.point_amount,
                                "onUpdate:modelValue": ($event: any) => ((row.point_amount) = $event),
                                min: 1,
                                placeholder: `${_ctx.pointLabel}数量`
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.pointLabel), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_el_input_number, {
                                modelValue: row.reward_rate,
                                "onUpdate:modelValue": ($event: any) => ((row.reward_rate) = $event),
                                min: 0,
                                max: 1,
                                step: 0.01,
                                precision: 4,
                                placeholder: "0.03"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "step"]),
                              _hoisted_18
                            ]))
                      ], 64))
                    : (row.item_type === 'coupon')
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 2,
                          modelValue: row.coupon_id,
                          "onUpdate:modelValue": ($event: any) => ((row.coupon_id) = $event),
                          filterable: "",
                          placeholder: "选择优惠券",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couponOptions, (coupon) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: coupon.id,
                                label: `${coupon.name} (${
                    coupon.coupon_type === 'fixed' ? '满减' : '折扣'
                  } ${coupon.discount_value}${
                    coupon.coupon_type === 'fixed' ? '元' : '%'
                  })`,
                                value: coupon.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数量",
              width: "150"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input_number, {
                  modelValue: row.quantity,
                  "onUpdate:modelValue": ($event: any) => ((row.quantity) = $event),
                  min: 1,
                  disabled: row.item_type === 'point',
                  size: "small"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "排序",
              width: "100"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input_number, {
                  modelValue: row.sort_order,
                  "onUpdate:modelValue": ($event: any) => ((row.sort_order) = $event),
                  min: 0,
                  size: "small",
                  "controls-position": "right"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "80"
            }, {
              default: _withCtx(({ $index }) => [
                _createVNode(_component_el_button, {
                  type: "danger",
                  size: "small",
                  onClick: ($event: any) => (_ctx.removeItem($index))
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_form_item, { class: "mt-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}